import PropTypes from 'prop-types';
import React, { useEffect, useState } from "react";

import DebugLogger from "../../../helpers/DebugLogger";

import 'react-calendar/dist/Calendar.css';
import Calendar from "react-calendar";
import "./DateSelect.scss";

import FormField from '../FormField/FormField';
import { getLongDateString } from '../../../helpers/Dates';

const DateSelect = (props) => {
    const {initialDate, id, selectFunc, allowPast, label, showLabel, labelNote, calendarOffset, allowEmpty, placeholder} = props;

    const [showCalendar, setShowCalendar] = useState(false);
    const toggleCalendar = (e) => setShowCalendar(!showCalendar);

    const [selectedDate, setSelectedDate] = useState(() => {
        if (typeof initialDate === 'number') return new Date(initialDate);
        if (initialDate) return initialDate;
        return allowEmpty ? null : new Date();
    });

    useEffect(() => {
        if (typeof initialDate === 'number') {
            setSelectedDate(new Date(initialDate));
            return;
        }

        if (initialDate) {
            setSelectedDate(initialDate);
            return;
        }

        setSelectedDate(allowEmpty ? null : new Date());
    }, [initialDate, allowEmpty]);

    const dateSelected = (val, e) => {
        e.preventDefault();

        setSelectedDate(val);
        if (selectFunc) {
            selectFunc(id, val);
        }
    }

    const calendarOffsetStyle = calendarOffset ? {marginLeft: calendarOffset} : {};
    if (props.lowStyle) {
        calendarOffsetStyle.bottom = props.lowStyle;
    }

    return (
        <div className="date-select-holder">
            {showCalendar &&
            <>
                <div className="close-calendar" onClick={toggleCalendar}></div>
                <div className="calendar-holder" style={calendarOffsetStyle}>
                    <Calendar 
                        onChange={dateSelected} 
                        minDate={allowPast ? null : new Date()}
                        minDetail="year"
                        defaultValue={selectedDate || new Date()}
                    />
                </div>
                </>
            }
            <FormField
                showLabel={showLabel}
                label={label}
                labelNote={labelNote}
                showError={false}
                value={selectedDate ? getLongDateString(Math.floor(selectedDate.getTime())) : ''}
                type="text"
                id={id || "date_selector"}
                placeholder={placeholder}
                readonly={true}
                onClick={toggleCalendar}
            />
        </div>
    )
}

const defaultSelectFunc = (id, val) => {
    DebugLogger.warn('You should provide a function called setFun(id, val) to DateSelect.');
    DebugLogger.attention('Selected Date: ', val);
}

DateSelect.propTypes = {
    id: PropTypes.string,
    initialDate: PropTypes.object,
    selectFunc: PropTypes.func,
    allowPast: PropTypes.bool,
    label: PropTypes.string,
    showLabel: PropTypes.bool,
    inlineLabel: PropTypes.bool,
    labelNote: PropTypes.string,
    calendarOffset: PropTypes.any,
    allowEmpty: PropTypes.bool,
    placeholder: PropTypes.string,
}

DateSelect.defaultProps = {
    id: "date_selector",
    initialDate: null,
    selectFunc: defaultSelectFunc,
    allowPast: false,
    label: 'Date',
    showLabel: false,
    inlineLabel: false,
    labelNote: '',
    calendarOffset: null,
    lowStyle: '-10rem',
    allowEmpty: false,
    placeholder: 'Date',
}

export default DateSelect;
